import { useState, useEffect } from "react";
import BottomPageButton from "../components/BottomPageButton";
import MainSection from "./home_sections/MainSection";
import AboutUsSection from "./home_sections/AboutUsSection";
import ServicesSection from "./home_sections/ServicesSection";
import ReviewsSection from "./home_sections/ReviewsSection";
import ContactSection from "./home_sections/ContactSection";
import Footer from "./Footer";
import NewsSection from "./home_sections/NewsSection";
import SecurityAlertArticlePage from "./articles/SecurityAlertArticlePage";
import { featuredArticle } from "../data/featuredArticle";
import { getPageData } from "../api/page";

import "../styles/App.css";

function App() {
  const [pageData, setPageData] = useState({ news: [], reviews: [] });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getPageData()
      .then((res) => setPageData(res.data))
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, []);

  const normalizedPath = window.location.pathname.replace(/\/+$/, "") || "/";

  if (normalizedPath === featuredArticle.path) {
    return <SecurityAlertArticlePage />;
  }

  return (
    <div className="App">
      <BottomPageButton />

      <MainSection />

      <NewsSection news={pageData.news} isLoading={isLoading} />

      <AboutUsSection />

      <ServicesSection />

      <ReviewsSection reviews={pageData.reviews} isLoading={isLoading} />

      {/* <TwitchSection /> */}

      <ContactSection />

      {/* <EasterEgg /> */}

      <Footer />
    </div>
  );
}

export default App;
